import { useTranslation } from '@frontend/i18n';
import { ConfirmationModal, ModalControlModalProps } from '@frontend/design-system';
import { ScheduleRequestsTrackingIds } from '../../trackingIds';

interface Props extends ModalControlModalProps {
  onConfirm: () => void;
}

export const ScheduleRequestDismissConfirmationModal = ({ onConfirm, ...modalProps }: Props) => {
  const { t } = useTranslation('schedule-request');

  return (
    <ConfirmationModal
      {...modalProps}
      title={t('Confirm')}
      message={t('Are you sure you want to dismiss this request?')}
      onConfirm={onConfirm}
      destructive
      cancelTrackingId={ScheduleRequestsTrackingIds.dismissConfirmationModalCancelBtn}
      confirmTrackingId={ScheduleRequestsTrackingIds.dismissConfirmationModalConfirmBtn}
    />
  );
};
